import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { assetDomain } from "../../../../config/config";
import { convertGptSummary } from "../../../../functions/job";
import {
  AiSummaryContainer,
  AiSummaryText,
  AiSummaryTextContainer,
  AiSummaryTitle,
  AiSummaryTitleContainer,
  AiSummaryTitleText,
  AshleyImage,
  SparklesIconStyled,
  SpeechTail,
  SummaryBulletItem,
  SummaryBulletList,
} from "./styles";

function SingleJobAiSummary(props) {
  const { job } = props || {};

  const { i18n } = useTranslation();
  const isBahasa =
    (i18n?.language || "en").split("-")[0].toLowerCase() === "ms";

  const displaySummary = useMemo(
    () => convertGptSummary(job, { preferBahasa: isBahasa }),
    [job, isBahasa]
  );

  return (
    <AiSummaryContainer>
      <AiSummaryTitleContainer>
        <AshleyImage
          draggable={false}
          src={assetDomain + "/images/hiredly/ashley-image.svg"}
          alt="ashley-avatar-image"
        />
        <AiSummaryTitleContainer>
          <AiSummaryTitle>
            <SparklesIconStyled />
            <AiSummaryTitleText variant="body1">
              AI-generated summary
            </AiSummaryTitleText>
          </AiSummaryTitle>
        </AiSummaryTitleContainer>
      </AiSummaryTitleContainer>

      <AiSummaryTextContainer>
        <AiSummaryText
          variant="body1"
          component="div"
          aria-label="chatgpt-job-summary"
        >
          {displaySummary.length > 0 ? (
            Array.isArray(displaySummary) ? (
              <SummaryBulletList>
                {displaySummary.map((line, index) => (
                  <SummaryBulletItem key={index}>{line}</SummaryBulletItem>
                ))}
              </SummaryBulletList>
            ) : (
              displaySummary
            )
          ) : (
            "Oops, looks like Ashley forgot to summarize this job! We apologize for the inconvenience. Please read the complete Job Description for full details and additional information."
          )}
        </AiSummaryText>
        <SpeechTail />
      </AiSummaryTextContainer>
    </AiSummaryContainer>
  );
}

export default SingleJobAiSummary;
